import React, { useState } from "react";
import { NavLink, useNavigate, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { label: "AI Labs", to: "/ai-labs" },
  { label: "Experts", to: "/experts" },
  { label: "How FIAD Works", to: "/how-it-works" },
  { label: "About", to: "/about" },
];

const FOUNDER_MAIL = "mailto:contact.fiad@gmail.com?subject=FIAD%20%E2%80%94%20Founder%20conversation";

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 w-full bg-[#0A0A0A]/85 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <Logo variant="light" testId="nav-logo" />

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm link-underline transition-colors ${isActive ? "text-[#C79447]" : "text-[#A1A1AA] hover:text-[#F6F3EC]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-5">
          <button data-testid="nav-expert-login" onClick={() => navigate("/login")} className="text-sm text-[#A1A1AA] hover:text-[#F6F3EC] link-underline">Sign in</button>
          <Link data-testid="nav-founder-cta" to="/pilot" className="text-sm font-medium bg-[#F6F3EC] text-[#0A0A0A] px-4 py-2 hover:bg-white transition-colors">Discuss a Pilot</Link>
        </div>

        <button data-testid="nav-menu-toggle" onClick={() => setOpen((v) => !v)} className="md:hidden text-[#F6F3EC] p-1" aria-label="Toggle menu">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0A0A0A]" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-base text-[#F6F3EC]">{l.label}</NavLink>
            ))}
            <button onClick={() => { setOpen(false); navigate("/login"); }} className="text-left text-base text-[#A1A1AA]">Sign in</button>
            <Link to="/pilot" onClick={() => setOpen(false)} className="text-center text-sm font-medium bg-[#F6F3EC] text-[#0A0A0A] px-4 py-3 mt-1">Discuss a Pilot</Link>
          </div>
        </div>
      )}
    </header>
  );
}

export { FOUNDER_MAIL };
